import { FormikErrors } from 'formik';
import { size } from 'es-toolkit/compat';

import valid from 'card-validator';

export interface CreditCardFields {
  cvc: string;
  expiry: string;
  name: string;
  number: string;
  zipCode: string;
  skipAvsCheck: boolean;
  saveNewCard: boolean;
}

export function validateFormikCreditCardValues(
  values: CreditCardFields
): FormikErrors<CreditCardFields> {
  const { number, expiry, cvc, zipCode, name } = values;
  const errors: FormikErrors<CreditCardFields> = {};
  const numberValidation = valid.number(number);

  if (!numberValidation.isValid) {
    errors.number = 'Your card number is invalid.';
  }

  const expiryValidation = valid.expirationDate(expiry);

  if (!expiryValidation.isValid) {
    errors.expiry = 'Your expiration date is invalid.';
  }

  const cvvValidation = valid.cvv(
    cvc,
    numberValidation.card ? numberValidation.card.code.size : undefined
  );

  if (!cvvValidation.isValid) {
    errors.cvc = 'Your security code is invalid.';
  }

  if (size((name ?? '').trim()) === 0) {
    errors.name = "Please enter the cardholder's name.";
  }

  if (size((zipCode ?? '').trim()) === 0) {
    errors.zipCode = 'Please enter a Zip/Postal code.';
  }

  if (zipCode && size((zipCode ?? '').trim()) > 10) {
    errors.zipCode = 'Zip/Postal code must contain no more than 9 characters.';
  }

  return errors;
}
